import {animate} from "../../../../lib";

export default class ResultPage {
	constructor($root, mainController) {
		/* Elements */
		this.$root = $root;
		this.$resultPage = this.$root.querySelector('.quiz-page.-result');
		this.$pageBody = this.$resultPage.querySelector('.quiz-result');
		this.$answersNum = this.$root.querySelector('.svg-spinner_value');
		this.$svg = this.$root.querySelector('.quiz-result_spinner');
		this.$circle = this.$svg.querySelector('.svg-spinner_circle');

		this.isInitialized = false;
		this.animationDelay = 500;
		this.correct = null;
		this.resultCount = null;

		/* Components */
		this.mainController = mainController;
	}

	init(switchPageCallback) {
		if (!this.isInitialized) {
			ResultPage.prototype.switchPage = switchPageCallback;
		}

		this.bootstrap();
	}

	bootstrap() {
		this.circumference = +this.$circle.getAttribute('r') * 2 * 3.14;
		this.$circle.style.strokeDasharray = this.circumference;
		this.$circle.style.strokeDashoffset = this.circumference;

		this.correct = this.mainController.totalCorrect;
		this.resultCount = this.correct / this.mainController.getTotalQuestions();
		this.setupResult();

		costorage.set('h_specialEventPopup', 1, { expires: (7 * 24 * 60 * 60), path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
	}

	setupResult() {
		this.animateSpinner();
		this.writeCircularDiagramResultCount();
	}

	animateSpinner() {
		const offset = this.circumference * (1 - this.resultCount);
		const diff = this.circumference - offset;

		setTimeout(() => {
			animate({
				timing: (t) => t,
				draw: (progress) => {
					this.$circle.style.strokeDashoffset = this.circumference - (diff * progress);
				},
				duration: 300
			});
		}, this.animationDelay);
	}

	writeCircularDiagramResultCount() {
		this.$answersNum.textContent = this.correct === 0 ? `100 ₴` : `${this.correct * 100} ₴`;
	}
}